<template>
<transition
appear
@enter="enter"
>
<div v-if="pageData" class="c-mv1" :class="{'c-mv1--modal': pageData.modal}">
  <div class="c-mv1__bg"></div>
  <div class="c-mv1__main" @click="openModal">
    <span class="is-shape" :style="styleShape"></span>
    <span class="is-wrap">
      <img :src="pageData.photo.src" alt="" width="750" height="1174" />
    </span>
    <button v-if="pageData.modal" class="c-btnModal c-btnModal--rd">
      <span></span>
    </button>
  </div>
  <div class="c-mv1__sd">
    <button class="c-btnScroll" @click="scrollDown">
      <div class="c-btnScroll__text">SCROLL DOWN</div>
      <div class="c-btnScroll__bar">
        <span>
        </span>
      </div>
    </button>
  </div>
</div>
</transition>
</template>

<script>
import {gsap, Power2, Power3, Expo} from 'gsap/all';

export default {
  data() {
    return {
      pageData: null,
      modal: null,
      shapeSize: 1174 / 750 * 100,
    }
  },
  props: ['name'],
  computed: {
    styleShape() {
      return {paddingTop: `${this.shapeSize}%`};
    }
  },
  mounted() {
    // ページデータ
    this.pageData = this.$store.getters.pageData[this.name];
    // モーダル
    this.modal = this.pageData.modal;

    // 画像 横or縦
    const img = new Image();
    img.onload = () => {
      this.loaded({width: img.width, height: img.height});
    }
    img.src = this.pageData.photo.src;
  },
  methods: {
    enter(el, done) {
      // 初期位置
      const photo = el.querySelector('.c-mv1__main .is-wrap');
      gsap.set(photo, {scale: 1.3, opacity: 0});

      done();
    },
    once() {
      // 画像表示
      const bg = this.$el.querySelector('.c-mv1__bg');
      const photo = this.$el.querySelector('.c-mv1__main .is-wrap');

      let viewPhoto = gsap.timeline({onComplete: this.onceComp});
      viewPhoto.addLabel('start')
      .fromTo(bg, {
        opacity: 0,
      }, {
        duration: 1.0,
        opacity: 1,
        ease: Power2.easeInOut,
      }, 'start')
      .fromTo(photo, {
        scale: 1.3,
        y: '-50%',
      }, {
        duration: 2.0,
        scale: 1,
        y: '0%',
        ease: Expo.easeOut,
      }, 'start+=0.2')
      .fromTo(photo, {
        opacity: 0,
      }, {
        duration: 1.9,
        opacity: 1,
        ease: Expo.easeInOut,
      }, 'start+=0.3');

    },
    onceComp() {
      const photo = this.$el.querySelector('.c-mv1__main .is-wrap');
      gsap.set(photo, {clearProps: 'all'});
    },
    openModal() {
      this.$store.commit('setCurrentModal', this.$store.getters.modalData[this.modal]);
      this.$store.commit('setShowModal', true);
    },
    loaded(e) {
      this.shapeSize = e.height / e.width * 100;
      this.$nextTick(this.once);
    },
    scrollDown() {
      const toY = this.getScrollTop() + this.$el.getBoundingClientRect().bottom;
      gsap.to(window, {duration: 0.8, scrollTo: {y: toY, autoKill: false}, ease: Power3.easeInOut});
    },
    getScrollTop() {
      return window.scrollY || document.documentElement.scrollTop || document.body.scrollTop;
    },
  }
}
</script>